import type { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { ImageComponent } from '@/components/Image';
import {
  BONANZA_LABEL_TEXT,
  type BonanzaPromoStatus,
} from '@/modules/promotions/helpers';
import { ScStatusLabel } from './styled';

interface ILabelTextProps {
  status: BonanzaPromoStatus;
  nextIterationStartDay?: string | null;
}

export const StatusLabel: FC<ILabelTextProps> = ({
  status,
  nextIterationStartDay,
}) => {
  const { t } = useTranslation('bonanzaPromo');

  const labelKey = BONANZA_LABEL_TEXT[status];

  if (!labelKey) return null;

  return (
    <ScStatusLabel status={status}>
      <ImageComponent
        alt="bubble decoration"
        className="bubble"
        height={150}
        src="/common/bubble.webp"
        width={150}
      />
      <span>{t(labelKey, { day: nextIterationStartDay })}</span>
    </ScStatusLabel>
  );
};
